import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faHistory } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './MesasData.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import NewMesa from '../NewMesa/NewMesa';
import { usePlan } from '../../PlanContext';

export default function MesasData() {
    const { features } = usePlan();
    const limites = features?.limites || {};
    const [mesas, setMesas] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [historialVisible, setHistorialVisible] = useState(false);
    const [mesaHistorial, setMesaHistorial] = useState(null);
    const [pedidosMesa, setPedidosMesa] = useState([]);
    const [mesa, setMesa] = useState({});
    const [numero, setNumero] = useState('');
    const [capacidad, setCapacidad] = useState('');
    const [estado, setEstado] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [filtroDesde, setFiltroDesde] = useState(new Date().toISOString().split('T')[0]);
    const [filtroHasta, setFiltroHasta] = useState(new Date().toISOString().split('T')[0]);

    useEffect(() => {
        cargarMesas();
    }, []);

    const cargarMesas = () => {
        fetch(`${baseURL}/mesasGet.php`)
            .then(response => response.json())
            .then(data => setMesas(data.mesas || []))
            .catch(error => console.error('Error al cargar mesas:', error));
    };

    const verHistorial = (item) => {
        setMesaHistorial(item);
        setHistorialVisible(true);
        cargarHistorialMesa(item.idMesa);
    };

    const cargarHistorialMesa = (idMesa) => {
        const params = new URLSearchParams({ idMesa });
        if (filtroDesde) params.append('desde', filtroDesde);
        if (filtroHasta) params.append('hasta', filtroHasta);
        fetch(`${baseURL}/mesaHistorial.php?${params}`)
            .then(r => r.json())
            .then(data => setPedidosMesa(data.pedidos || []))
            .catch(err => console.error(err));
    };

    const totalHistorial = pedidosMesa.reduce((sum, p) => sum + parseFloat(p.total || 0), 0);

    const eliminarMesa = (idMesa) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/mesaDelete.php?idMesa=${idMesa}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarMesas();
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const abrirModal = (item) => {
        setMesa(item);
        setNumero(item.numero);
        setCapacidad(item.capacidad);
        setEstado(item.estado);
        setDescripcion(item.descripcion);
        setModalVisible(true);
    };

    const cerrarModal = () => setModalVisible(false);

    const handleUpdate = (idMesa) => {
        const payload = {
            numero:      numero      !== '' ? numero      : mesa.numero,
            capacidad:   capacidad   !== '' ? capacidad   : mesa.capacidad,
            estado:      estado      !== '' ? estado      : mesa.estado,
            descripcion: descripcion !== '' ? descripcion : mesa.descripcion,
        };

        fetch(`${baseURL}/mesaPut.php?idMesa=${idMesa}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error!', data.error, 'error');
                } else {
                    Swal.fire('Editado!', data.mensaje, 'success');
                    cargarMesas();
                    cerrarModal();
                }
            })
            .catch(error => toast.error(error.message));
    };

    const badgeEstado = (est) => {
        const colores = {
            disponible: '#28a745',
            ocupada:    '#dc3545',
            reservada:  '#ffc107',
        };
        return (
            <span style={{
                background: colores[est] || '#6c757d',
                color: est === 'reservada' ? '#000' : '#fff',
                padding: '3px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '600',
            }}>
                {est}
            </span>
        );
    };

    return (
        <div>
            <ToastContainer />
            <NewMesa onCrear={cargarMesas} />
            {mesas.filter(m => m.descripcion !== 'Mesa General').length >= (limites.mesas ?? 6) && (
                <div style={{
                    background: '#fff8e1',
                    border: '1px solid #ffc107',
                    color: '#7a5b00',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    marginBottom: '16px',
                    fontSize: '13px',
                }}>
                    ⚠️ Alcanzaste el límite de {limites.mesas ?? 6} mesas. Adquirí un paquete para agregar más.
                </div>
            )}

            {modalVisible && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Mesa</button>
                            <span className='close' onClick={cerrarModal}>&times;</span>
                        </div>
                        <div className='flexGrap'>
                            <fieldset>
                                <legend>Número de Mesa</legend>
                                <input
                                    type='number'
                                    value={numero}
                                    onChange={(e) => setNumero(e.target.value)}
                                    min='1'
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Capacidad (personas)</legend>
                                <input
                                    type='number'
                                    value={capacidad}
                                    onChange={(e) => setCapacidad(e.target.value)}
                                    min='1'
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Estado</legend>
                                <select value={estado} onChange={(e) => setEstado(e.target.value)}>
                                    <option value='disponible'>Disponible</option>
                                    <option value='ocupada'>Ocupada</option>
                                    <option value='reservada'>Reservada</option>
                                </select>
                            </fieldset>
                            <fieldset>
                                <legend>Descripción</legend>
                                <input
                                    type='text'
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                />
                            </fieldset>
                        </div>
                        <button className='btnPost' onClick={() => handleUpdate(mesa.idMesa)}>
                            Guardar
                        </button>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>N° Mesa</th>
                            <th>Capacidad</th>
                            <th>Estado</th>
                            <th>Descripción</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mesas.map(item => (
                            <tr key={item.idMesa}>
                                <td><strong>Mesa {item.numero}</strong></td>
                                <td>{item.capacidad} personas</td>
                                <td>{badgeEstado(item.estado)}</td>
                                <td>{item.descripcion || '—'}</td>
                                <td>
                                    <button className='editar' onClick={() => verHistorial(item)} title='Ver historial'>
                                        <FontAwesomeIcon icon={faHistory} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)} title='Editar'>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarMesa(item.idMesa)} title='Eliminar'>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {historialVisible && mesaHistorial && (
                <div className='modal'>
                    <div className='modal-content modal-wide'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Historial - Mesa {mesaHistorial.numero}</button>
                            <span className='close' onClick={() => setHistorialVisible(false)}>&times;</span>
                        </div>
                        <div className='historialFiltros'>
                            <fieldset>
                                <legend>Desde</legend>
                                <input type='date' value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Hasta</legend>
                                <input type='date' value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} />
                            </fieldset>
                            <button className='btnPost' onClick={() => cargarHistorialMesa(mesaHistorial.idMesa)}>Filtrar</button>
                        </div>
                        <div className='historialResumen'>
                            <div className='resumenCard'>
                                <span>Total Pedidos</span>
                                <strong>{pedidosMesa.length}</strong>
                            </div>
                            <div className='resumenCard'>
                                <span>Total Ventas</span>
                                <strong>{moneda} {String(Math.round(totalHistorial)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                            </div>
                            <div className='resumenCard'>
                                <span>Trabajadores</span>
                                <strong>{[...new Set(pedidosMesa.map(p => p.trabajadorNombre).filter(Boolean))].length}</strong>
                            </div>
                        </div>
                        {pedidosMesa.length === 0 ? (
                            <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>Sin pedidos en este rango de fechas</p>
                        ) : (
                            <div className='table-container'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Pedido</th>
                                            <th>Trabajador</th>
                                            <th>Productos</th>
                                            <th>Total</th>
                                            <th>Estado</th>
                                            <th>Fecha/Hora</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pedidosMesa.map(p => {
                                            const prods = typeof p.productos === 'string' ? JSON.parse(p.productos) : p.productos;
                                            return (
                                                <tr key={p.idPedido}>
                                                    <td>#{p.idPedido}</td>
                                                    <td>{p.trabajadorNombre || '—'}</td>
                                                    <td>{(prods || []).map(pr => `${pr.cantidad}x ${pr.titulo}`).join(', ')}</td>
                                                    <td><strong>{moneda} {String(Math.round(parseFloat(p.total))).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong></td>
                                                    <td>{badgeEstado(p.estado === 'Entregado' ? 'disponible' : p.estado === 'Pendiente' ? 'reservada' : 'ocupada')}{' '}{p.estado}</td>
                                                    <td>{new Date(p.createdAt).toLocaleString()}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
